import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <div className="logo-text">
                <h1 style={{ fontSize: '1.6rem' }}>Shachar High-Tech</h1>
                <h2 style={{ fontSize: '1.0rem' }}>Software Development</h2>
              </div>
            </div>
            
            <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
              <a href="#home" onClick={() => scrollToSection('home')}>Home</a>
              <a href="#services" onClick={() => scrollToSection('services')}>Services</a>
              <a href="#about" onClick={() => scrollToSection('about')}>About</a>
              <a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a>
            </nav>

            <button 
              className="login-btn"
              onClick={() => setIsLoginOpen(true)}
            >
              Customer Login
            </button>

            <button 
              className="mobile-menu-btn"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {isLoginOpen && (
        <div className="login-modal-overlay" onClick={() => setIsLoginOpen(false)}>
          <div className="login-modal" onClick={(e) => e.stopPropagation()}>
            <button className="login-modal-close" onClick={() => setIsLoginOpen(false)}>
              ✕
            </button>
            <h2 className="login-modal-title">Customer Login</h2>
            <p className="login-modal-subtitle">Sign in to access your account</p>
            
            <form className="login-form" onSubmit={(e) => { e.preventDefault(); alert('Login authentication failed. If you forgot your password, please contact support@shachar-ht.com'); }}>
              <div className="login-form-group">
                <label htmlFor="email">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  placeholder="Enter your email" 
                  required 
                />
              </div>
              
              <div className="login-form-group">
                <label htmlFor="password">Password</label>
                <input 
                  type="password" 
                  id="password" 
                  placeholder="Enter your password" 
                  required 
                />
              </div>
              
              <div className="login-form-options">
                <label className="login-checkbox">
                  <input type="checkbox" />
                  <span>Remember me</span>
                </label>
                <a href="#" className="login-forgot">Forgot password?</a>
              </div>
              
              <button type="submit" className="login-submit-btn">
                Sign In
              </button>
            </form>
            
            <div className="login-footer">
              <p>Don't have an account? <a href="#">Contact us</a></p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
